import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import {
    Layout,
    Row,
    Popconfirm,
    Button,
    Col,
    Card,
    Icon,
    PageHeader,
    Tabs,
    Tag,
    Modal,
    DatePicker,
    Spin,
    Skeleton
} from 'antd'
import moment from 'moment'
import Clients from './Clients'
import CommissionList from './Commissions/CommissionList'
import { CommissionRatesEdit } from './Commissions/CommissionPercents'
import { CommissionTotals } from './Commissions/CommissionTotals'
import Files from '../../Clients/Client/Files'
import SubAgents from './SubAgents'
import SubAgentCommissionList from './Commissions/SubAgentCommissionList'
import AgentTopSection from './AgentTopSection'
import UploadFilePopup from '@components/Popup/UploadFilePopup'
import MentorCreditCommission from './Commissions/CreateNewCommission/MentorCredit'
import MentorDebtCommission from './Commissions/CreateNewCommission/MentorDebt'
import { users, files, subscriptions, commissions } from '@services/api'
import UserMessages from '../UserMessages'
import { isCoordinatorOnly } from '@utils/roles'

@inject((store: any) => {
    const { popupStore, authStore, subscriptionsStore } = store

    return {
        popupStore,
        authStore,
        subscriptionsStore
    }
})
@observer
class Agent extends Component<any> {
    state = {
        loading: true,
        clients: [],
        subAgents: [],
        commission: { typeNew: { total: 0, rows: [] }, provided: { total: 0, rows: [] } },
        commissionList: 'loading',
        commissionTotals: '',
        commissionPagination: { page: 1, perPage: 10, total: 1, lastPage: 1, count: 0 },
        subAgentCommissions: '',
        agentInfo: {},
        files: [],
        soldSubscriptions: [],
        counts: {
            bestCare: 0,
            smile: 0,
            Gold: 0,
            GoldPlus: 0,
            mediwhoAllIn: 0,
            mediwhoAssistant: 0,
            BundleSoulBestCare: 0,
            BundleSoulGold: 0,
            BundleSimpleSmileBestCare: 0,
            BundleSimpleSmileGold: 0,
            magenDavidK: 0,
            soulCare: 0,
            mediwho360: 0,
            SimpleSmile: 0,
            mediwho: 0,
            critical: 0,
            BundleCriticalGold: 0,
            BundleCriticalGoldPlus: 0,
            BundleCriticalBestCare: 0,
            BundleCriticalSimpleSmile: 0,
            hospitalPlus: 0,
            BundleBestCareHospital: 0,
            BundleMediWhoGoldHospital: 0,
            BundleGoldPlusHospital: 0,
            BundleSoulHospital: 0,
            BundleSimpleSmileHospital: 0,
            BundleCriticalHospital: 0,
            BundleAllInHospital: 0,
            BundleSimpleSmileGoldHospital: 0,
            BundleBestCareSmileGoldHospital: 0,
            noSub: 0,
            deleted: 0
        },
        top_agent: false,
        updateMentorMode: false,
        authorizedPhones: ''
    }

    _isMounted = false

    async componentDidMount() {
        this._isMounted = true
        const { subscriptionsStore } = this.props
        await this.updateInfo()
        // subscriptionsStore.getSubscriptions()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    componentDidUpdate(prevProps) {
        const currentId = this.props.computedMatch.params.id
        const prevId = prevProps.computedMatch.params.id

        if (currentId !== prevId) {
            this.updateInfo()
        }
    }

    async handleRemoveUser() {
        const { id } = this.state.agentInfo
        try {
            await users.deleteAgent(id)
            this.props.history.push(`/clients`)
        } catch (err) {
            if (err && err.response && err.response.data && err.response.data.msg) {
                alert(err.response.data.msg)
            }
        }
    }

    handleCanceledSubscription = async userSubscriptionId => {
        try {
            const user_id = this.props.computedMatch.params.id
            const payload = {
                user_id: user_id,
                user_subscription_id: userSubscriptionId
            }
            await subscriptions.canceledSpecificSub(payload)
            await this.updateInfo()
        } catch (err) {
            if (err && err.response && err.response.status === 409) {
                alert(err.response.data)
            }
        }
    }

    agentClientsPaginate = async ({ page }) => {
        const agent_id = this.props.computedMatch.params.id
        try {
            const agentClients = await users.getAgent({ agent_id, page: page.current })
            this.setState({
                // clients
                ...agentClients.data
            })
        } catch (err) {
            // Swallow so the caller's .then runs and the table loader is cleared.
            console.log('agentClientsPaginate::', err)
        }

        return false
    }

    updateInfo = async () => {
        const {
            commissionPagination: { page, perPage }
        } = this.state
        const { subscriptionsStore } = this.props
        const agent_id = this.props.computedMatch.params.id

        this.setState({ loading: true })

        try {
            // agent info
            await users.getAgentInfo({ agent_id }).then(result => {
                this.setState({
                    // agent info
                    agentInfo: result.data,
                    topAgent: result.data.top_agent,
                    updateMentorMode: !!!result.data.mentor
                })
            })

            // authorized phones
            await users.getAuthorizedPhones({ agent_id }).then(result => {
                this.setState({ authorizedPhones: result.data })
            })

            // clients
            await users.getAgent({ agent_id }).then(result => {
                this.setState({ ...result.data })
            })

            // commissions totals
            await commissions.getAgentCommissionTotals({ id: agent_id }).then(result => {
                this.setState({ commissionTotals: result.data })
            })

            // sub agent commissions
            await commissions.getSubAgentCommissions({ id: agent_id }).then(result => {
                this.setState({ subAgentCommissions: result.data })
            })

            // agent commissions
            await commissions.getAgentCommissions({ agent_id, page, perPage }).then(result => {
                this.setState({
                    commissionList: result.data.data,
                    commissionPagination: {
                        page: result.data.page,
                        perPage: result.data.perPage,
                        total: result.data.total,
                        lastPage: result.data.lastPage,
                        count: result.data.count
                    }
                })
            })

            // subs list
            // await subscriptionsStore.getSubscriptions()

            // this.setState({
            //     loading: false
            // })
        } catch (err) {
            console.log('updateInfo::', err)
            alert('אירעה שגיאה')
        } finally {
            if (this._isMounted) this.setState({ loading: false })
        }
    }

    // updateInfo = async () => {
    //     // <====== prev version
    //     this.setState({ loading: true }, () => {
    //         const agent_id = this.props.computedMatch.params.id
    //
    //         users.getAgent({ agent_id }).then(res => {
    //             this.setState({ ...res.data })
    //         })
    //
    //         users.getAgentInfo({ agent_id }).then(res => {
    //             this.setState({
    //                 agentInfo: res.data,
    //                 topAgent: res.data.top_agent,
    //                 updateMentorMode: !!!res.data.mentor,
    //                 loading: false
    //             })
    //         })
    //     })
    //
    //     this.getAgentCommissions()
    //     this.getAgentCommissionTotals()
    //     this.getSubAgentCommissions()
    //     this.getAuthorizedPhones()
    // }

    getAuthorizedPhones = () => {
        const agent_id = this.props.computedMatch.params.id
        users.getAuthorizedPhones({ agent_id }).then(res => {
            this.setState({ authorizedPhones: res.data })
        })
    }

    getAgentCommissions = (params = {}) => {
        const { client_id, this_ } = params
        const agent_id = this.props.computedMatch.params.id
        const {
            commissionPagination: { page, perPage }
        } = this.state

        commissions
            .getAgentCommissions({ agent_id, client_id, page, perPage })
            .then(res => {
                const data = res.data.data
                const { page, perPage, total, lastPage, count } = res.data
                this.setState({
                    commissionList: data,
                    commissionPagination: { page, perPage, total, lastPage, count }
                })
                // this_ is the caller component; it may be absent on direct calls.
                this_ && this_.setState({ loader: false })
            })
            .catch(err => {
                console.log('getAgentCommissions::', err)
                this_ && this_.setState({ loader: false })
            })
        // .then((res) => this.setState({ commissionList: res.data }))
    }

    paginateCommissions = ({ page, perPage, client_id, this_ }) => {
        this.setState(
            {
                commissionPagination: { ...this.state.commissionPagination, page, perPage }
            },
            () => this.getAgentCommissions({ client_id, this_ })
        )
    }

    getAgentCommissionTotals = () => {
        const id = this.props.computedMatch.params.id
        commissions.getAgentCommissionTotals({ id }).then(res => this.setState({ commissionTotals: res.data }))
    }

    getSubAgentCommissions = () => {
        const id = this.props.computedMatch.params.id
        commissions.getSubAgentCommissions({ id }).then(res => this.setState({ subAgentCommissions: res.data }))
    }

    updateAgentInfo = async () => {
        const agent_id = this.props.computedMatch.params.id
        const agentInfo = (await users.getAgentInfo({ agent_id })).data
        this.setState({ agentInfo })
    }

    handleDeleteFile = async id => {
        await files.delete({ id })
        await this.updateInfo()
    }

    handleUnblockAgent = async () => {
        const { agentInfo } = this.state
        try {
            await users.unblockAgent({ agent_id: agentInfo.id })
            this.updateInfo()
            alert('החסימה שוחררה בהצלחה! יש לבצע התנתקות והתחברות מחדש')
        } catch (err) {
            console.log(err)
            alert('שגיאה בעת שחרור החסימה')
        }
    }

    handleBlockAgentWithDate = () => {
        let selectedDate = moment()

        Modal.confirm({
            title: 'חסימת סוכן',
            content: (
                <div style={{ direction: 'rtl' }}>
                    <p>פעולה זו תחסום את הסוכן מהקמות ורכישות.</p>
                    <p>בחרו תאריך חסימה:</p>
                    <DatePicker
                        defaultValue={selectedDate}
                        onChange={date => {
                            selectedDate = date
                        }}
                        style={{ width: '100%' }}
                    />
                </div>
            ),
            okText: 'בצע חסימה',
            cancelText: 'ביטול',
            onOk: async () => {
                try {
                    const { agentInfo } = this.state
                    await users.blockAgent({
                        agent_id: agentInfo.id,
                        blocked_from: selectedDate.format('YYYY-MM-DD')
                    })
                    alert('הסוכן נחסם בהצלחה')
                    this.updateInfo()
                } catch (err) {
                    console.log(err)
                    alert('שגיאה בביצוע החסימה')
                }
            }
        })
    }

    render() {
        const { TabPane } = Tabs
        const {
            agentInfo,
            files,
            loading,
            clients,
            commissionList,
            commissionTotals,
            subAgentCommissions,
            subAgents,
            counts,
            authorizedPhones
        } = this.state

        const {
            authStore: { roles },
            popupStore
        } = this.props
        // prettier-ignore
        const headerTitle = !agentInfo['first_name'] ? 'טוען...' : `${agentInfo['first_name']} ${agentInfo['last_name']} (${agentInfo['id']})`
        const isAdmin = roles.includes('admin') || roles.includes('moderator') || roles.includes('developer')

        const isParentAgent = subAgents && subAgents.length > 0
        const coordinatorOnly = isCoordinatorOnly(roles)

        const subAgentsList = subAgents.map(subAgent => {
            const { first_name, last_name, id, phone, current_month_subs_count, total_subs_count } = subAgent

            return {
                first_name,
                last_name,
                phone,
                id,
                current_month_subs_count,
                total_subs_count
            }
        })

        return (
            <Layout style={{ padding: '0 1rem' }}>
                <PageHeader
                    onBack={() => window.history.back()}
                    title={headerTitle}
                    subTitle={
                        agentInfo['isBlocked'] || agentInfo['blocked_from_date'] ? (
                            <div
                                style={{
                                    color: 'red',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '1rem'
                                }}
                            >
                                {agentInfo['isBlocked']
                                    ? 'חסום לביצוע הקמות / רכישות'
                                    : `חסום לביצוע הקמות / רכישות החל מ - ${moment(
                                          agentInfo['blocked_from_date']
                                      ).format('DD/MM/YYYY')}`}
                                {(roles.includes('admin') || roles.includes('moderator')) && (
                                    <Popconfirm
                                        title="האם אתם בטוחים?"
                                        onConfirm={this.handleUnblockAgent}
                                        okText="כן"
                                        cancelText="לא"
                                    >
                                        <Button type="default" size="small">
                                            שחרור חסימה
                                        </Button>
                                    </Popconfirm>
                                )}
                            </div>
                        ) : (
                            <></>
                        )
                    }
                />

                <AgentTopSection
                    agentInfo={agentInfo}
                    updateInfo={this.updateInfo}
                    authorizedPhones={authorizedPhones}
                    getAuthorizedPhones={this.getAuthorizedPhones}
                />

                <Row gutter={10}>
                    <Col>
                        <Tabs type="card">
                            {!coordinatorOnly && (
                            <TabPane tab="לקוחות" key="CLIENTS">
                                <Card
                                    title={
                                        <div style={compStyles['cardTitle']}>
                                            לקוחות ({clients.total ? clients.total - (counts.deleted || 0) : 0})
                                            <div style={compStyles['subsList']}>
                                                {counts.mediwho > 0 ? (
                                                    <div>{`MediWho: ${counts.mediwho} | `}</div>
                                                ) : null}
                                                {counts.mediwho360 > 0 ? (
                                                    <div>{`MediWho360: ${counts.mediwho360} | `}</div>
                                                ) : null}
                                                {counts.bestCare > 0 ? (
                                                    <div>{`BestCare: ${counts.bestCare} | `}</div>
                                                ) : null}
                                                {counts.smile > 0 ? <div>{`Smile: ${counts.smile} | `}</div> : null}
                                                {counts.Gold > 0 ? <div>{`Gold: ${counts.Gold} | `}</div> : null}
                                                {counts.GoldPlus > 0 ? (
                                                    <div>{`Gold Plus: ${counts.GoldPlus} | `}</div>
                                                ) : null}
                                                {counts.mediwhoAssistant > 0 ? (
                                                    <div>{`Assistant: ${counts.mediwhoAssistant} | `}</div>
                                                ) : null}
                                                {counts.soulCare > 0 ? (
                                                    <div>{`Soul Care: ${counts.soulCare} | `}</div>
                                                ) : null}
                                                {counts.mediwhoAllIn > 0 ? (
                                                    <div>{`All In: ${counts.mediwhoAllIn} | `}</div>
                                                ) : null}
                                                {counts.BundleSoulBestCare > 0 ? (
                                                    <div>{`SoulBestCare: ${counts.BundleSoulBestCare} | `}</div>
                                                ) : null}
                                                {counts.BundleSoulGold > 0 ? (
                                                    <div>{`SoulCareGold: ${counts.BundleSoulGold} | `}</div>
                                                ) : null}
                                                {counts.BundleSimpleSmileBestCare > 0 ? (
                                                    <div>{`SimpleSmileBestCare: ${counts.BundleSimpleSmileBestCare} | `}</div>
                                                ) : null}
                                                {counts.BundleSimpleSmileGold > 0 ? (
                                                    <div>{`SimpleSmileGold: ${counts.BundleSimpleSmileGold} | `}</div>
                                                ) : null}
                                                {counts.SimpleSmile > 0 ? (
                                                    <div>{`SimpleSmile: ${counts.SimpleSmile} | `}</div>
                                                ) : null}
                                                {counts.critical > 0 ? (
                                                    <div>{`Critical: ${counts.critical} | `}</div>
                                                ) : null}
                                                {counts.BundleCriticalGold > 0 ? (
                                                    <div>{`CriticalGold: ${counts.BundleCriticalGold} | `}</div>
                                                ) : null}
                                                {counts.BundleCriticalGoldPlus > 0 ? (
                                                    <div>{`CriticalGoldPlus: ${counts.BundleCriticalGoldPlus} | `}</div>
                                                ) : null}
                                                {counts.BundleCriticalBestCare > 0 ? (
                                                    <div>{`CriticalBestCare: ${counts.BundleCriticalBestCare} | `}</div>
                                                ) : null}
                                                {counts.BundleCriticalSimpleSmile > 0 ? (
                                                    <div>{`CriticalSimpleSmile: ${counts.BundleCriticalSimpleSmile} | `}</div>
                                                ) : null}
                                                {counts.hospitalPlus > 0 ? (
                                                    <div>{`Mediwho אשפוז+: ${counts.hospitalPlus} | `}</div>
                                                ) : null}
                                                {counts.BundleCriticalAllIn > 0 ? (
                                                    <div>{`CriticalAllIn: ${counts.BundleCriticalAllIn} | `}</div>
                                                ) : null}
                                                {counts.BundleBestCareHospital > 0 ? (
                                                    <div>{`BestCare+אשפוז+: ${counts.BundleBestCareHospital} | `}</div>
                                                ) : null}
                                                {counts.BundleMediWhoGoldHospital > 0 ? (
                                                    <div>{`Gold+אשפוז+: ${counts.BundleMediWhoGoldHospital} | `}</div>
                                                ) : null}
                                                {counts.BundleGoldPlusHospital > 0 ? (
                                                    <div>{`GoldPlus+אשפוז+: ${counts.BundleGoldPlusHospital} | `}</div>
                                                ) : null}
                                                {counts.BundleSoulHospital > 0 ? (
                                                    <div>{`Soul+אשפוז+: ${counts.BundleSoulHospital} | `}</div>
                                                ) : null}
                                                {counts.BundleSimpleSmileHospital > 0 ? (
                                                    <div>{`SimpleSmile+אשפוז+: ${counts.BundleSimpleSmileHospital} | `}</div>
                                                ) : null}
                                                {counts.BundleCriticalHospital > 0 ? (
                                                    <div>{`Critical+אשפוז+: ${counts.BundleCriticalHospital} | `}</div>
                                                ) : null}
                                                {counts.BundleAllInHospital > 0 ? (
                                                    <div>{`AllIn+אשפוז+: ${counts.BundleAllInHospital} | `}</div>
                                                ) : null}
                                                {counts.BundleSimpleSmileGoldHospital > 0 ? (
                                                    <div>{`SimpleSmile+Gold+אשפוז+: ${counts.BundleSimpleSmileGoldHospital} | `}</div>
                                                ) : null}
                                                {counts.BundleBestCareSmileGoldHospital > 0 ? (
                                                    <div>{`BestCare+SmileGold+אשפוז+: ${counts.BundleBestCareSmileGoldHospital} | `}</div>
                                                ) : null}
                                                {counts.magenDavidK > 0 ? (
                                                    <div>{`מגן דוד כחול: ${counts.magenDavidK} | `}</div>
                                                ) : null}
                                                {counts.deleted > 0 ? <div>{`נמחקו: ${counts.deleted} | `}</div> : null}
                                                {counts.noSub > 0 ? <div>{`ללא מינוי: ${counts.noSub}`}</div> : null}
                                            </div>
                                        </div>
                                    }
                                    headStyle={{ backgroundColor: '#dadce0' }}
                                    bodyStyle={{ padding: '0.8rem 0.8rem' }}
                                >
                                    <Clients
                                        list={clients}
                                        updateInfo={this.updateInfo}
                                        loading={loading}
                                        paginate={this.agentClientsPaginate}
                                        isAdmin={isAdmin}
                                        agentName={`${agentInfo['first_name']} ${agentInfo['last_name']}`}
                                    />
                                </Card>
                            </TabPane>
                            )}
                            {isParentAgent && (
                                <TabPane tab="סוכני משנה" key="SUB_AGENTS">
                                    <Card
                                        title={<Fragment>סוכני משנה</Fragment>}
                                        headStyle={{ backgroundColor: '#dadce0' }}
                                        bodyStyle={{ padding: '0.8rem 0.8rem' }}
                                        style={{ marginBottom: '1rem' }}
                                    >
                                        <SubAgents
                                            list={subAgentsList}
                                            updateInfo={this.updateInfo}
                                            isAdmin={isAdmin}
                                            agentName={`${agentInfo['first_name']} ${agentInfo['last_name']}`}
                                        />
                                    </Card>
                                </TabPane>
                            )}

                            {(roles.includes('admin') ||
                                roles.includes('moderator') ||
                                roles.includes('money') ||
                                roles.includes('agents_moderator')) && (
                                <TabPane tab="אחוזי עמלות" key="PERCENTS">
                                    <Card
                                        title={<Fragment>אחוזי עמלות</Fragment>}
                                        headStyle={{ backgroundColor: '#dadce0' }}
                                        bodyStyle={{ padding: '0.8rem 0.8rem' }}
                                        style={{ marginBottom: '1rem' }}
                                    >
                                        <CommissionRatesEdit
                                            agentInfo={{ ...agentInfo, subAgents }}
                                            updateInfo={this.updateAgentInfo}
                                        />
                                    </Card>
                                </TabPane>
                            )}
                        </Tabs>
                    </Col>
                </Row>

                {!coordinatorOnly && (
                <Row gutter={10}>
                    <Col>
                        <div>
                            {this.props.popupStore.popupType == 'mentorCreditCommission' ? (
                                <MentorCreditCommission />
                            ) : (
                                ''
                            )}
                            {this.props.popupStore.popupType == 'mentorDebtCommission' ? <MentorDebtCommission /> : ''}
                        </div>
                        <Tabs type="card" className="agent-commissions-tabs">
                            <TabPane tab="עמלות אישיות" key="commissions">
                                <Card
                                    title={
                                        <Fragment>
                                            עמלות
                                            <CommissionTotals totals={commissionTotals} />
                                        </Fragment>
                                    }
                                    headStyle={{ backgroundColor: '#dadce0' }}
                                    bodyStyle={{ padding: '0.8rem 0.8rem' }}
                                    style={{ marginBottom: '1rem' }}
                                >
                                    <CommissionList
                                        commissions={commissionList}
                                        agentInfo={{ ...agentInfo, subAgents }}
                                        getAgentCommissions={this.getAgentCommissions}
                                        getAgentCommissionTotals={this.getAgentCommissionTotals}
                                        paginateCommissions={this.paginateCommissions}
                                        commissionPagination={this.state.commissionPagination}
                                    />
                                </Card>
                            </TabPane>
                            {isParentAgent && (
                                <TabPane tab="עמלות סוכני משנה" key="subAgents">
                                    <Card
                                        title={
                                            <>
                                                עמלות סוכני משנה
                                                <CommissionTotals totals={commissionTotals} />
                                            </>
                                        }
                                        headStyle={{ backgroundColor: '#dadce0' }}
                                        bodyStyle={{ padding: '0.8rem 0.8rem' }}
                                        style={{ marginBottom: '1rem' }}
                                    >
                                        <SubAgentCommissionList subAgentCommissions={subAgentCommissions} />
                                    </Card>
                                </TabPane>
                            )}
                        </Tabs>
                    </Col>
                </Row>
                )}
                {!coordinatorOnly && (
                <Row gutter={10}>
                    <Col>
                        <Card
                            title={
                                <Fragment>
                                    קבצים
                                    <Button
                                        onClick={() =>
                                            popupStore.togglePopup('uploadFile', {
                                                bucket: 'clients',
                                                related: agentInfo['id'],
                                                types: ['doc']
                                            })
                                        }
                                        disabled={loading}
                                        style={{ float: 'left', margin: '-0.3rem 2rem' }}
                                    >
                                        <Icon type="upload" /> העלאת קובץ
                                    </Button>
                                </Fragment>
                            }
                            headStyle={{ backgroundColor: '#dadce0' }}
                            bodyStyle={{ padding: '0.8rem 0.8rem' }}
                            style={{ marginBottom: '1rem' }}
                        >
                            <Files deleteFile={id => this.handleDeleteFile(id)} list={files} />
                        </Card>
                    </Col>
                </Row>
                )}
                <UploadFilePopup fileUploaded={() => this.updateInfo()} />
                {agentInfo.id && !coordinatorOnly && <UserMessages clientInfo={agentInfo} />}

                <Row>
                    {!agentInfo['isBlocked'] && !agentInfo['blocked_from_date'] ? (
                        (roles.includes('admin') || roles.includes('moderator')) && (
                            <Button
                                type="default"
                                size="small"
                                style={{ color: 'red' }}
                                onClick={this.handleBlockAgentWithDate}
                            >
                                חסימה
                            </Button>
                        )
                    ) : (
                        <></>
                    )}
                    {agentInfo['status'] !== 'DELETED' &&
                    (roles.includes('admin') || roles.includes('moderator') || roles.includes('developer')) ? (
                        <Popconfirm
                            title="האם לבצע מחיקת משתמש?"
                            onConfirm={() => this.handleRemoveUser()}
                            okText="כן"
                            cancelText="לא"
                        >
                            {(roles.includes('admin') || roles.includes('developer')) && (
                                <Button type="danger" style={{ float: 'left' }}>
                                    מחיקת משתמש
                                </Button>
                            )}
                        </Popconfirm>
                    ) : (
                        ''
                    )}
                </Row>
            </Layout>
        )
    }
}

const compStyles = {
    cardTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'start',
        // justifyContent: 'space-between',
        gap: '1rem',
        width: '100%'
    },
    subsList: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'end',
        justifyContent: 'right',
        width: '90%',
        flexWrap: 'wrap',
        gap: '5px',
        direction: 'rtl'
    }
}

export default withRouter(Agent)
